import React, { useState, useRef, useEffect } from 'react';
import EmojiPicker from 'emoji-picker-react';
import { Smile } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const EmojiPickerButton = ({ onEmojiSelect, buttonSize = 'sm', buttonVariant = 'outline' }) => {
  const [showPicker, setShowPicker] = useState(false);
  const pickerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setShowPicker(false);
      }
    };

    if (showPicker) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showPicker]);

  const handleEmojiClick = (emojiObject) => {
    onEmojiSelect(emojiObject.emoji);
    setShowPicker(false);
  };

  return (
    <div className="relative" ref={pickerRef}>
      <Button
        type="button"
        size={buttonSize}
        variant={buttonVariant}
        onClick={() => setShowPicker(!showPicker)}
      >
        <Smile className="w-4 h-4" />
      </Button>
      
      {showPicker && (
        <div className="absolute bottom-full mb-2 z-50">
          <EmojiPicker
            onEmojiClick={handleEmojiClick}
            width={350}
            height={400}
            searchDisabled={false}
            skinTonesDisabled
            previewConfig={{ showPreview: false }}
          />
        </div>
      )}
    </div>
  );
};

// Basic emoji reaction component (predefined emojis)
export const EmojiReactions = ({ reactions = {}, onReact, currentUserId }) => {
  const basicEmojis = ['😀', '👍', '❤️', '🎉', '😢'];

  const getReactionCount = (emoji) => {
    return reactions[emoji]?.length || 0;
  };

  const hasUserReacted = (emoji) => {
    return reactions[emoji]?.includes(currentUserId) || false;
  };

  return (
    <div className="flex flex-wrap gap-2">
      {basicEmojis.map(emoji => {
        const count = getReactionCount(emoji);
        const userReacted = hasUserReacted(emoji);
        
        return (
          <button
            key={emoji}
            onClick={() => onReact(emoji)}
            className={`px-2 py-1 rounded-full text-sm flex items-center gap-1 transition-all ${
              userReacted
                ? 'bg-cyan-100 border-2 border-cyan-500 text-cyan-700'
                : 'bg-gray-100 border border-gray-300 hover:bg-gray-200'
            }`}
          >
            <span className="text-lg">{emoji}</span>
            {count > 0 && <span className="text-xs font-medium">{count}</span>}
          </button>
        );
      })}
    </div>
  );
};

export default { EmojiPickerButton, EmojiReactions };
